import { useState } from "react"

export function useHeader() {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0, top: 0, left: 0, x: 0, y: 0 })
  return { dimensions, setDimensions }
}
